import { render, staticRenderFns } from "./ValidateImport.vue?vue&type=template&id=32cbff1b&"
import script from "./ValidateImport.vue?vue&type=script&lang=js&"
export * from "./ValidateImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports